import { Component, Input } from '@angular/core';
import { PharmacyService } from '../services/pharmacy.service';
import { Pharmacy } from '../models/pharmacy.model';
import { LookupService } from '../services/lookup.service';
import { NotificationService } from '../services/notification.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-pharmacy-form',
  templateUrl: './pharmacy-form.component.html'
})
export class PharmacyFormComponent {
  constructor(public lookupService: LookupService, public service: PharmacyService, private notificationService: NotificationService) { }

  @Input() model: Pharmacy;

  options: any = { format: 'YYYY-MM-DD' };

  ngOnInit() {

  }

  getCitiesByState(id) {
    this.lookupService.getCitiesByState(id);
  }

  onStateChanged(data: { value: string[] }): void {
    this.getCitiesByState(data);
  }

  submitted = false;

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;
    if (!this.model.pharmacyID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {
    
    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.service.search();
        $('#PanelForm, #PanelMain').slideToggle();
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.service.search();
        $('#PanelForm, #PanelMain').slideToggle();
      },
      err => {
        console.log(err);
      }
    )
  }

}
 
